export class Setting {
  mode: string;
  hint: boolean;
  voice: string;
  rate: number;
  difficulty: number;
}
